import React from "react";
import { styled } from "@mui/material/styles";
import { Grid, Button, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import routes from "../../../../routes";
import { ReactComponent as ImageOutline } from "../../../../assets/icons/image-outline.svg";

const SectionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: theme.spacing(4),
  maxWidth: "600px",
  margin: "0 auto"
}));

const IconContainer = styled(ImageOutline)(({ theme }) => ({
  width: "80px",
  height: "80px",
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main
}));

const ContainerText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
  lineHeight: 1.6
}));

const BtnContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "150px",
  padding: theme.spacing(1.5, 3)
}));

export const UploadLimitComponent = () => {
  return (
    <SectionContainer>
      <Grid item xs={12}>
        <IconContainer alt="image icon" />
      </Grid>
      <ContainerText>
        Oops! you have reached the maximum no. of documents uploads. Let&apos;s have someone call
        you back within one day to help you out.
      </ContainerText>
      <ContainerText>Looking for other products or services to grow your business?</ContainerText>
      <BtnContainer item xs={12}>
        <Link to={routes.financeProductComparison}>
          <ActionButton onClick={() => ""} color="primary" variant="contained">
            Explore Now
          </ActionButton>
        </Link>
      </BtnContainer>
    </SectionContainer>
  );
};
